<template>
  <v-progress-linear indeterminate color="primary"></v-progress-linear>
</template>

<script>
export default {
  name: 'ProgressBar',
};
</script>
